/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var config = {
  name: 'useTagsResource',
  // REQUIRED Name of the data hook, should be the same as the file name.
  type: 'retrieve',
  // REQUIRED Data Hook type, currently retrieve or modify
  uri: '/account/api/tagging/resource?id={{0}}',
  // REQUIRED URL that will be called with this request
  method: 'GET',
  // REQUIRED REST method used for the API call
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },
  documentation: {
    model: {
      name: {
        type: 'String',
        description: 'Name of the tag'
      },
      resourceId: {
        type: 'String',
        description: 'ID of the resource'
      },
      success: {
        type: 'Boolean',
        description: 'Flag that indicates whether the request was successful or not'
      },
      tags: {
        type: 'Array',
        description: 'Array of tag objects attached to this resource'
      },
      type: {
        type: 'String',
        description: 'Type of the resource'
      }
    },
    params: 'This API takes no params'
  },
  mock: {
    // A mock response for the API. This will be returned if option.mock is set to true. Should match the model in the documentation
    name: 'Resource 1',
    resourceId: '123',
    success: true,
    tags: ['tag-2', 'tag-3'],
    access_tags: ['dev:tag-2'],
    type: ''
  }
};
var useTagsResourceConfig = config;

export { useTagsResourceConfig as default };
